import React from "react";
import { NavLink } from 'react-router-dom';
import { useMicrosoftAuth } from "../../context/MicrosoftAuthContext";

const SideBar = ({ isOpen, isCollapsed, toggle }) => {
  const { userTeamData } = useMicrosoftAuth();
  
  const navigationItems = [
    {
      name: "Dashboard",
      icon: "/assets/icons/dashboard.svg",
      path: "/dashboard",
      roleCheck: () => true // Always visible
    },
    {
      name: "Branches",
      icon: "/assets/icons/branches.svg", 
      path: "/branches",
      roleCheck: () => userTeamData?.user_role_id.includes("10") || userTeamData?.manager_has_branches || userTeamData?.area_director_has_branches
    },
    {
      name: "Managers",
      icon: "/assets/icons/managers.svg",
      path: "/manager", 
      roleCheck: () => userTeamData?.user_role_id.includes("10")
    },
    {
      name: "Assistants",
      icon: "/assets/icons/assistants.svg",
      path: "/assistants",
      roleCheck: () => userTeamData?.user_role_id.includes("10") || userTeamData?.user_role_id.includes("1")
    },
    {
      name: "Pods/Teams",
      icon: "/assets/icons/teams.svg", 
      path: "/teams_pods",
      roleCheck: () => userTeamData?.user_role_id.includes("10")
    }
  ];

  return (
    <div className={`sidebar-new ${isOpen ? 'sidebar-open' : ''} ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Logo Section */}
      <div className="sidebar-logo-section">
        <img
          src={isCollapsed ? "/assets/icons/logocollapsed.svg" : "/assets/icons/logowhite.svg"}
          alt="JAMESONS Logo"
          className="sidebar-logo"
        />
      </div>

      {/* Navigation Section */}
      <div className="sidebar-navigation">
        {navigationItems.map((item, index) => {
          if (!item.roleCheck()) return null;
          
          const currentPath = window.location.pathname;
          const isActive = currentPath === item.path || 
                          (item.path === "/manager" && currentPath === "/manager") ||
                          (item.path === "/teams_pods" && currentPath === "/teams_pods");

          return (
            <NavLink
              key={index}
              to={item.path}
              className="sidebar-nav-item"
            >
              <div className={`sidebar-nav-content ${isActive ? 'active' : ''}`}>
                <div className="sidebar-nav-icon">
                  <img
                    src={item.icon}
                    alt={item.name}
                    style={{
                      filter: isActive ? 'none' : 'brightness(0) invert(1)',
                      ...(isActive && {
                        filter: 'brightness(0) saturate(100%) invert(37%) sepia(77%) saturate(1040%) hue-rotate(8deg) brightness(96%) contrast(93%)'
                      })
                    }}
                  />
                </div>
                {!isCollapsed && (
                  <div className={`sidebar-nav-text ${isActive ? 'active' : ''}`}>
                    {item.name}
                  </div>
                )}
              </div>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default SideBar;
